import { tabAccessControl } from "../../../_helpers/access-control";

let PurchasePlanningTabs = [
  {
    text: "Generate",
    path: `/purchase-planning/create`,
    applicationFeatureCode: "PurchasePlanning",
  },
  {
    text: "Orders",
    path: `/purchase-planning-orders`,
    applicationFeatureCode: "PurchasePlanning",
  },
];


 function GetIndexByTabName(tabName){
  return tabAccessControl(PurchasePlanningTabs).findIndex((x) => x.text == tabName);
}
 
export { PurchasePlanningTabs, GetIndexByTabName };